//imports
import { all } from 'redux-saga/effects';

//Views
import packageOverviewSagas from 'Modules/packages/views/overview/redux/saga';
import packagesFeatureTabSagas from 'Modules/packages/.components/featureTab/redux/saga';
import createEditPackageSagas from 'Modules/packages/.components/createEditPackage/redux/saga';
import deletePackageSagas from 'Modules/packages/.components/deletePackage/redux/saga';
import assignedToTabSagas from 'Modules/packages/.components/assignedToTab/redux/saga';

//merge sagas
export default function* rootSaga() {
    yield all([
        packageOverviewSagas(),
        packagesFeatureTabSagas(),
        createEditPackageSagas(),
        deletePackageSagas(),
        assignedToTabSagas(),
    ]);
}